module.exports = __webpack_public_path__ + "img/panelView_defaultBg_strong_4_3.fbae8978.png";